export namespace Fallback {
  export const namespace = "fallback";

  export const nl = {
    title: "Er is iets misgegaan",
    text: "Er is iets misgegaan bij het laden van het formulier. Probeer het later opnieuw of neem contact op met de klantondersteuning."
  };

  export const en = {
    title: "Something went wrong",
    text: "Something went wrong while loading the form. Please try again later or contact customer support."
  };
}
